import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { MemberEvaluationService } from '../../../../../app/members/member-evaluation.service';
import { EvaluationForm } from '../models/evaluationForm';
import { MemberEvaluationStatus } from '../models/memberEvaluationStatus';
import { AccessibilityService } from 'src/app/shared/services/accessibility.service';

@Component({
  selector: 'app-evaluation-confirmation',
  templateUrl: './evaluation-confirmation.component.html',
  styleUrls: ['./evaluation-confirmation.component.scss'],
  standalone: false
})
export class EvaluationConfirmationComponent implements OnInit, OnDestroy {
  private _subscription: Subscription;
  private hasAnnounced: boolean = false;

  evaluation: EvaluationForm;

  private readonly DEFAULT_CONFIRMATION_MESSAGE: string =
    'Thank you for completing the evaluation.';

  constructor(
    private service: MemberEvaluationService,
    private accessibilityService: AccessibilityService
  ) {}

  ngOnDestroy(): void {
    if (this._subscription) this._subscription.unsubscribe();
  }

  ngOnInit(): void {
    this._subscription = this.service.evaluation.subscribe((result) => {
      if (result) {
        this.evaluation = result;
        this.service.setEvaluationForm();
        this.announceConfirmation();
      }
    });
  }

  /**
   * Announces the submission result to screen readers.
   *
   * This cannot run from a lifecycle hook: the evaluation arrives asynchronously, so the
   * confirmation text is not known when the view first renders. Without it a screen reader
   * only hears the route title, which is the same title as the evaluation page the user just
   * left, so nothing conveys that the response was submitted (WCAG 2.1 SC 4.1.3).
   */
  private announceConfirmation() {
    if (this.hasAnnounced) {
      return; //the subject can emit more than once. Only the first arrival is news
    }

    if (this.evaluation?.status !== MemberEvaluationStatus.Complete) {
      return; //setEvaluationForm is redirecting away. This is not the confirmation
    }

    this.hasAnnounced = true;
    //read the title directly rather than via hasConfirmationTitle: that getter uses isNil, so
    //an empty string counts as a title and the announcement would be dropped as empty,
    //leaving the page silent
    this.accessibilityService.talk(
      this.evaluation?.confirmationTitle?.trim() || this.DEFAULT_CONFIRMATION_MESSAGE
    );
  }
}
